import itemAspectRatio from '../../../../common/utils/itemAspectRatio'

// Last row less than 60% of the averageImagesPerRow
const tolerance = 0.4

const calculateRowSize = items =>
  items.reduce((total, item) => {
    return total + itemAspectRatio(item)
  }, 0)

const isRowUnbalanced = (row, averageImagesPerRow) =>
  row.size < averageImagesPerRow - averageImagesPerRow * tolerance

/*
 * Balances rows from bottom to top with a tolerance
 */
export const balanceRows = (originalRows, averageImagesPerRow) => {
  // Don't bother if there is only a couple of rows
  if (originalRows.length < 2) {
    return originalRows
  }

  // Clone so we can use push and unshift etc.
  const rows = [...originalRows].map(row => ({
    ...row,
    items: [...row.items]
  }))

  const lastRowIndex = rows.length - 1
  const unbalanced = isRowUnbalanced(rows[lastRowIndex], averageImagesPerRow)

  if (unbalanced) {
    const newLastRow = rows[lastRowIndex - 1].items.concat(
      rows[lastRowIndex].items
    )
    rows[lastRowIndex - 1].items = newLastRow
    rows[lastRowIndex - 1].size = calculateRowSize(rows[lastRowIndex - 1].items)

    rows.length = rows.length - 1
  }

  return rows
}
